import {
  ADMIN_LOGIN,
  AdminSpinner,
  Button,
  DeleteIcon,
  Div,
  H3,
  Modal,
  P,
  PropsModal,
  SuccessToast,
  deleteAccount,
  reportError,
} from '@vgrubs/components';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const DeleteAccountModal = ({
  modalIsOpen,
  closeModal,
}: PropsModal & {
  modalIsOpen: boolean;
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  async function handleDeleteAccount() {
    try {
      setLoading(true);
      const { data } = await deleteAccount();

      SuccessToast(data.message);
      navigate(ADMIN_LOGIN);
      setLoading(false);
    } catch (error) {
      reportError(error);
      setLoading(false);
    }
  }

  return (
    <>
      {loading && <AdminSpinner />}
      <Modal
        isOpen={modalIsOpen}
        closeModal={closeModal}
        logo={false}
        exitButton={false}
      >
        <Div $mb="16">
          <DeleteIcon />
        </Div>

        <H3 $m="10px" $center>
          Delete Account
        </H3>
        <P $mb="24" $center>
          Deleting your account is permanent, erases everything, and can't be
          undone. Are you sure?
        </P>

        <Div $flex $gap="16px">
          <Button onClick={handleDeleteAccount} $w="100%" $selected>
            Yes
          </Button>
          <Button $w="100%" onClick={() => closeModal?.()} $gray $selected>
            No
          </Button>
        </Div>
      </Modal>
    </>
  );
};
